import { lazy, Suspense } from "react";
import { useLocation } from "react-router";

import { shouldShowAdminStaticExportLauncher } from "@/utils/deployEnvironment";

const LazyAdminStaticExportLauncher = lazy(() =>
  import("@/components/staticExport/AdminStaticExportLauncher").then(
    (module) => ({ default: module.AdminStaticExportLauncher }),
  ),
);

const isLauncherHiddenRoute = (pathname: string): boolean =>
  pathname === "/login" || pathname.startsWith("/share/docs/");

/**
 * The static export launcher, only on staging and preview hosts for a
 * signed-in admin. It moved here unchanged when the floating Log issue and
 * AI Assistant buttons became top bar side panels (Nav PRD §7, §8, §11);
 * App.tsx already keeps it out of screenshot mode.
 */
export const AdminStaticExportLauncherMount = ({
  currentUserId,
}: {
  currentUserId?: string | null;
}) => {
  const location = useLocation();
  if (
    !currentUserId ||
    isLauncherHiddenRoute(location.pathname) ||
    !shouldShowAdminStaticExportLauncher()
  ) {
    return null;
  }

  return (
    <div data-hc-static-export-ignore>
      <Suspense fallback={null}>
        <LazyAdminStaticExportLauncher />
      </Suspense>
    </div>
  );
};
